<template>
  <div class="content-box">
    <div class="wrapperd">
      <div class="content">
        <div class="content_left">
          <p class="title">{{ perName }}-作者投稿</p>
          <div>
            <Form
              class="form_box"
              ref="params"
              :model="params"
              :rules="ruleValidate"
              :label-width="100"
            >
              <FormItem label="文章标题" prop="title">
                <Input
                  v-model="params.title"
                  placeholder="请输入文章标题"
                  :maxlength="100"
                />
              </FormItem>
              <FormItem label="作者" prop="must">
                <div class="first">
                  <p>
                    第一作者<Icon
                      v-if="!params.oneAuthor.name"
                      type="md-add-circle"
                      class="add"
                      @click="addAuthor(1)"
                    />
                  </p>
                  <div class="author" v-if="params.oneAuthor.name">
                    <span class="name" @click="infos(1, params.oneAuthor)">{{
                      params.oneAuthor.name
                    }}</span>
                    <span>{{ params.oneAuthor.professional }}</span>
                    <span>{{ params.oneAuthor.researchSubject }}</span>
                    <span>{{ params.oneAuthor.companyName }}</span>
                    <span @click="del(1)"
                      ><Icon type="ios-trash" class="del"
                    /></span>
                  </div>
                </div>
                <div class="other">
                  <p>
                    其他作者<Icon
                      v-if="params.authorRequestList.length < 6"
                      type="md-add-circle"
                      class="add"
                      @click="addAuthor(2)"
                    />
                  </p>
                  <div
                    class="author"
                    v-for="(item, index) in params.authorRequestList"
                    :key="index"
                  >
                    <span class="name" @click="infos(2, item, index)">{{
                      item.name
                    }}</span>
                    <span>{{ item.professional }}</span>
                    <span>{{ item.researchSubject }}</span>
                    <span>{{ item.companyName }}</span>
                    <span @click="del(2, index)"
                      ><Icon type="ios-trash" class="del"
                    /></span>
                  </div>
                </div>
                <div class="commu">
                  <p>
                    通信作者<Icon
                      type="md-add-circle"
                      class="add"
                      @click="addAuthor(3)"
                    />
                  </p>
                  <div class="author" v-if="params.correspondingAuthor.name">
                    <span
                      class="name"
                      @click="infos(3, params.correspondingAuthor)"
                      >{{ params.correspondingAuthor.name }}</span
                    >
                    <span>{{ params.correspondingAuthor.professional }}</span>
                    <span>{{
                      params.correspondingAuthor.researchSubject
                    }}</span>
                    <span>{{ params.correspondingAuthor.companyName }}</span>
                    <span @click="del(3)"
                      ><Icon type="ios-trash" class="del"
                    /></span>
                  </div>
                </div>
              </FormItem>
              <FormItem label="摘要">
                <Input
                  v-model="params.summary"
                  type="textarea"
                  :maxlength="100"
                  placeholder="请输入文章摘要"
                />
              </FormItem>
              <FormItem label="关键词">
                <Input
                  v-model="params.articleKey"
                  placeholder="请输入关键词，多个关键字用'，'隔开"
                  :maxlength="100"
                />
              </FormItem>
              <FormItem label="中图分类号" prop="libraryClassifyNumber">
                <Input
                  v-model="params.libraryClassifyNumber"
                  placeholder="按中图分类法填写"
                  style="width: 300px"
                />
                <a
                  href="http://ztflh.xhma.com"
                  target="_blank"
                  style="color: #508bb5"
                  >中图分类法</a
                >
              </FormItem>
              <FormItem label="本文研究领域" prop="">
                <Select
                  v-model="params.researchField.levelOne"
                  style="width: 197px"
                  @on-change="changeResearch"
                  placeholder="请选择"
                >
                  <Option
                    v-for="(item, index) in oneSubjectList"
                    :label="item.subjectName"
                    :value="String(item.id)"
                    :key="index"
                  ></Option>
                </Select>
                <Select
                  v-model="params.researchField.levelTwo"
                  @on-change="changeResearch1"
                  style="width: 197px"
                  placeholder="请选择"
                >
                  <Option
                    v-for="(item, index) in twoResearchList"
                    :label="item.subjectName"
                    :value="String(item.id)"
                    :key="index"
                  >
                  </Option>
                </Select>
                <Select
                  v-if="threeResearchList"
                  v-model="params.researchField.levelThree"
                  style="width: 197px"
                >
                  <Option
                    v-for="(item, index) in threeResearchList"
                    :label="item.subjectName"
                    :value="String(item.id)"
                    :key="index"
                  >
                  </Option>
                </Select>
                <Input
                  v-if="!threeResearchList"
                  v-model="params.researchField.custom"
                  autocomplete="off"
                  style="width: 197px"
                  placeholder="请填写"
                />
              </FormItem>
              <FormItem label="是否基金文章" prop="foundationFlag">
                <RadioGroup v-model="params.foundationFlag" @on-change="change">
                  <Radio label="1">是</Radio>
                  <Radio label="0">否</Radio>
                </RadioGroup>
                <sup
                  v-if="
                    obj.fundPreferential == 1 && obj.fundPreferentialContent
                  "
                  @click="modal3 = true"
                  style="
                    color: red;
                    padding: 10px;
                    background: yellow;
                    cursor: pointer;
                  "
                  >优惠</sup
                >
              </FormItem>
              <FormItem
                label="基金项目"
                prop="foundationItemList"
                v-if="params.foundationFlag == 1"
              >
                <div
                  v-for="(sub, index) in params.foundationItemList"
                  :key="index"
                  class="foundationItemLists"
                >
                  <FormItem
                    :prop="`foundationItemList.${index}.fundLevel`"
                    :rules="FundProjects.fundLevel"
                    style="float: left; margin-bottom: 60px"
                  >
                    <Select v-model="sub.fundLevel" style="width: 110px">
                      <Option
                        v-for="(item, index) in fundList"
                        :value="item.value"
                        :key="item.value"
                        >{{ item.label }}</Option
                      >
                    </Select>
                  </FormItem>
                  <FormItem
                    :prop="`foundationItemList.${index}.fundNo`"
                    :rules="FundProjects1.fundNo"
                    style="float: left; margin-bottom: 60px"
                  >
                    <Input
                      v-model="sub.fundNo"
                      type="text"
                      placeholder="请输入基金来源或类别"
                      style="
                        width: 170px;
                        margin-right: 10px;
                        margin-left: 10px;
                      "
                    />
                  </FormItem>
                  <FormItem
                    :prop="`foundationItemList.${index}.fundName`"
                    :rules="FundProjects2.fundName"
                    style="float: left; margin-bottom: 60px"
                  >
                    <Input
                      v-model="sub.fundName"
                      type="text"
                      placeholder="请输入基金编号"
                      style="width: 100px"
                    />
                  </FormItem>
                  <FormItem
                    :prop="`foundationItemList.${index}.fundFileList`"
                    :rules="FundProjects3.fundFileList"
                    style="float: left; margin-bottom: 60px"
                  >
                    <Upload
                      :max-size="20480"
                      :action="$global.url + '/web/common/upload'"
                      :show-upload-list="false"
                      :default-file-list="sub.fundFileList.name"
                      class="break_box_upload vc"
                      accept=".jpg,.png,.pdf"
                      :format="['jpg', 'png', 'pdf']"
                      :on-format-error="handleFormatError"
                      :name="'file'"
                      :on-success="handleSuccess3"
                    >
                      <Button
                        icon="ios-cloud-upload-outline"
                        style="margin-left: 10px; margin-right: 10px"
                        @click="getIndex(index)"
                        >证明材料</Button
                      >
                    </Upload>
                    <Button @click="addFund(index)" style="margin-right: 10px"
                      >+</Button
                    >
                    <Button
                      v-if="params.foundationItemList.length > 1"
                      @click="delFund(index)"
                      >删除</Button
                    >
                    <ul class="Echo" style="margin-top: 10px; margin-left: 50%">
                      <li
                        v-for="(item, cindex) in params.foundationItemList[
                          index
                        ].fundFileList"
                        :key="cindex"
                      >
                        <Poptip trigger="hover" :content="item.name">{{
                          item.name
                        }}</Poptip>
                        <Icon
                          v-if="
                            params.foundationItemList[index].fundFileList.length
                          "
                          type="ivu-icon ivu-icon-ios-trash"
                          @click="deletes(index, cindex)"
                        />
                        <a
                          v-if="params.foundationItemList[index].fundFileList"
                          icon="ios-cloud-upload-outline"
                          @click="download(index, cindex)"
                          >下载</a
                        >
                      </li>
                    </ul>
                  </FormItem>
                </div>
              </FormItem>
              <FormItem label="稿件" prop="articlePath">
                <Upload
                  :max-size="20480"
                  :action="$global.url + '/web/common/upload'"
                  :show-upload-list="true"
                  :default-file-list="defaultList1"
                  class="break_box_upload vc"
                  accept=".docx,.doc"
                  :name="'file'"
                  :on-success="handleSuccess1"
                >
                  <Button
                    icon="ios-cloud-upload-outline"
                    style="margin-right: 6px"
                    >稿件上传</Button
                  ><span style="color: red; margin-left: 10px"
                    >稿件大小不要大于20M</span
                  >
                </Upload>
                <a
                  v-if="params.articlePath"
                  icon="ios-cloud-upload-outline"
                  download="fujian"
                  :href="$global.imgUrl + params.articlePath"
                  >下载</a
                >
              </FormItem>
              <FormItem label="附件" prop="annexPath">
                <Upload
                  :action="$global.url + '/web/common/upload'"
                  :show-upload-list="true"
                  :default-file-list="defaultList"
                  class="break_box_upload vc"
                  :name="'file'"
                  :on-success="handleSuccess"
                >
                  <Button
                    icon="ios-cloud-upload-outline"
                    style="margin-right: 6px"
                    >附件上传</Button
                  >
                </Upload>
                <a
                  v-if="params.annexPath"
                  icon="ios-cloud-upload-outline"
                  download="fujian"
                  :href="$global.imgUrl + params.annexPath"
                  >下载</a
                >
              </FormItem>
              <!-- <FormItem label="上传版权协议" prop="copyrightAgreement">
								<Upload :action="$global.url+'/web/common/upload'" type="drag" :show-upload-list="false" accept=".png,.jpg,.jpeg,.gif" class="break_box_upload vc uploadClass" :name="'file'" :on-success="handleSuccess2">
									<img v-if="params.copyrightAgreement" class="coverImg" :src="$global.imgUrl+params.copyrightAgreement" alt="">
				                    <div class="center" v-if="!params.copyrightAgreement">
				                        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
				                        <p>图片上传</p>
				                    </div>
			                    </Upload>
							</FormItem> -->
              <v-item
                :info="contributionInfo"
                :rel="params"
                :commitSatus="status"
                @fun="getData"
                style="width: 100%"
              ></v-item>

              <FormItem class="button">
                <Button type="primary" class="btn" @click="saveInfo"
                  >保存</Button
                >
                <Button type="primary" class="btn" @click="nextStep('params')"
                  >下一步</Button
                >
              </FormItem>
            </Form>
          </div>
        </div>
        <div class="content_right" v-if="flag == 1">
          <div class="container">
            <p class="title">退修意见</p>
            <div v-html="tuixiuOpinion"></div>
            <p class="title" v-if="recommendData.length">参考推荐</p>
            <div v-for="(item, index) in recommendData" :key="index">
              <p
                @click="checkBK(item)"
                style="
                  color: #5036ff;
                  cursor: pointer;
                  line-height: 2;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                "
              >
                {{ item.title }}
              </p>
            </div>
          </div>
          <p v-if="postilFile" @click="copyDown(1, postilFile)" class="down">
            批注文档下载
          </p>
        </div>
        <div class="content_right" v-else>
          <div class="container">
            <p class="title">版权协议</p>
            <div v-html="obj.copyrightAgreement"></div>
          </div>
          <p
            v-if="obj.copyrightAgreementTransfer"
            @click="copyDown(2, obj.copyrightAgreementTransfer)"
            class="down"
          >
            《版权协议转让书》下载
          </p>
        </div>
      </div>

      <!--添加作者  注册用户-->
      <Modal
        v-model="modal1"
        :title="title"
        :mask-closable="false"
        :footer-hide="true"
        :closable="false"
      >
        <Form
          v-show="animal == '已注册用户'"
          ref="formValidate1"
          :model="formValidate1"
          :rules="ruleValidate1"
          :label-width="60"
          class="form_box"
        >
          <RadioGroup v-model="animal" class="animal">
            <Radio label="已注册用户"></Radio>
            <!-- <Radio label="非注册用户" v-if="authorType== 1" disabled></Radio>
						<Radio label="非注册用户" v-else></Radio> -->
          </RadioGroup>
          <!-- ------------------------------------------------------------------------------------------ -->
          <v-item1
            v-if="animal == '已注册用户'"
            :info="addInfo"
            :rel="formValidate1"
            :commitSatus="status1"
            @inputChange="getData1"
          ></v-item1>

          <div class="spam">
            <span v-if="resultFlag == 2"
              >系统中无此作者信息,<a href="javascript:;" @click="span()"
                >去创建</a
              ></span
            >
          </div>
          <FormItem>
            <Button
              type="primary"
              @click="suggesSubmit1('formValidate1')"
              style="
                float: right;
                margin-left: 20px;
                margin-top: 10px;
                width: 60px;
                height: 36px;
              "
              >确定</Button
            >
            <Button
              @click="suggesReset1('formValidate1')"
              style="
                margin-right: 20px;
                float: right;
                margin-top: 10px;
                width: 60px;
                height: 36px;
              "
              >取消</Button
            >
          </FormItem>
        </Form>
        <!-- ------------------------------------------------------------------------------------------------ -->
        <!-- <Form v-show="animal== '非注册用户'" ref="formValidate3" :model="formValidate3" :rules="ruleValidate3" :label-width="60" class="form_box">
					 <RadioGroup v-model="animal" class="animal">
						<Radio label="已注册用户" ></Radio>
						<Radio label="非注册用户" v-if="authorType== 1" disabled></Radio>
						<Radio label="非注册用户" v-else></Radio>
					</RadioGroup>
		
					<v-item v-if="animal== '非注册用户'" :info="system" :rel="formValidate3" :commitSatus="status3" @fun="getData3"></v-item>

                    <FormItem>
						<Button type="primary" @click="suggesSubmit3('formValidate3')" style="float: right;margin-left: 20px;margin-top: 10px;width: 60px;height: 36px;">确定</Button>
						<Button @click="suggesReset3('formValidate3')" style="margin-right: 20px;float: right;margin-top: 10px;width: 60px;height: 36px;">取消</Button>
					</FormItem>
				</Form> -->
      </Modal>

      <!--添加作者基本信息-->
      <Modal
        v-model="modal2"
        :width="700"
        :title="title"
        :mask-closable="false"
        :footer-hide="true"
      >
        <Form
          ref="formValidate2"
          :model="formValidate2"
          :rules="ruleValidate2"
          :label-width="90"
          class="form_box"
        >
          <v-item2
            :info="addAuthorInfo"
            :rel="formValidate2"
            :commitSatus="status2"
            @fun="getData2"
          >
            <v-city
              slot="city"
              :item="formValidate2"
              :provinceList="provinceList"
              :cityStatus="'false'"
              :index="0"
              @fun="getCity"
            ></v-city>
          </v-item2>
          <div class="">
            <div style="margin-bottom: 20px">
              <span
                v-for="(sub, index) in formValidate2.titleList"
                :key="index"
                class="achieveC"
              >
                <FormItem
                  label="职称"
                  :prop="`titleList.${index}.titleLevelTwo`"
                  :rules="totalDictRules.titleLevelThree"
                >
                  <!--:prop="`titleList.${index}.levelThree`" :rules="totalDictRules.levelThree"-->
                  <Select
                    v-model="sub.titleLevelOne"
                    @click.native="zindex = index"
                    @on-change="dictScChange1"
                    style="width: 150px"
                  >
                    <Option value="0" label="其他"></Option>
                    <Option
                      v-for="(item, index) in dictList"
                      :label="item.name"
                      :value="String(item.id)"
                      :key="index"
                    ></Option>
                  </Select>
                  <Select
                    v-model="sub.titleLevelTwo"
                    style="width: 150px"
                    @click.native="zindex = index"
                    @on-change="dictScChange2"
                  >
                    <Option label="初级" value="4"></Option>
                    <Option label="中级" value="3"></Option>
                    <Option label="副高级" value="2"></Option>
                    <Option label="正高级" value="1"></Option>
                  </Select>
                  <Select
                    v-model="sub.titleLevelThree"
                    v-if="sub.titleLevelOne != 0"
                    style="width: 150px"
                  >
                    <Option
                      v-for="(item, index) in sub.dictScThree"
                      :label="item.titleName"
                      :value="String(item.id)"
                      :key="index"
                    ></Option>
                  </Select>
                  <Input
                    v-if="sub.titleLevelOne == 0"
                    v-model="sub.custom"
                    autocomplete="off"
                    style="width: 150px"
                    placeholder="请填写"
                  />
                  <Button
                    v-if="formValidate2.titleList.length > 1"
                    @click="delDict(index)"
                    >删除</Button
                  >
                </FormItem>
              </span>
              <Button
                @click="addDict"
                v-if="formValidate2.titleList.length < 5"
                style="margin-top: -10px; margin-left: 90px"
                >+</Button
              >
            </div>
            <div
              v-for="(sub, index) in formValidate2.subjectList"
              :key="index"
              class="achieveC"
            >
              <FormItem
                label="研究方向"
                :prop="
                  sub.threeSubjectList
                    ? `subjectList.${index}.levelThree`
                    : `subjectList.${index}.custom`
                "
                :rules="
                  sub.threeSubjectList
                    ? subjectRules.levelThree
                    : subjectRules.custom
                "
              >
                <Select
                  v-model="sub.levelOne"
                  style="width: 150px"
                  @click.native="zindex = index"
                  @on-change="changeScholr"
                  placeholder="请选择"
                >
                  <Option
                    v-for="(item, index) in oneSubjectList"
                    :label="item.subjectName"
                    :value="String(item.id)"
                    :key="index"
                  ></Option>
                </Select>
                <Select
                  v-model="sub.levelTwo"
                  placeholder=""
                  @click.native="zindex = index"
                  @on-change="changeScholr1"
                  style="width: 150px"
                  placeholder="请选择"
                >
                  <Option
                    v-for="(item, index) in sub.twoSubjectList"
                    :label="item.subjectName"
                    :value="String(item.id)"
                    :key="index"
                  >
                  </Option>
                </Select>
                <Select
                  v-if="sub.threeSubjectList"
                  v-model="sub.levelThree"
                  style="width: 150px"
                >
                  <Option
                    v-for="(item, index) in sub.threeSubjectList"
                    :label="item.subjectName"
                    :value="String(item.id)"
                    :key="index"
                  >
                  </Option>
                </Select>
                <Input
                  v-if="!sub.threeSubjectList"
                  v-model="sub.custom"
                  autocomplete="off"
                  style="width: 150px"
                  placeholder="请填写"
                />
                <Button
                  v-if="formValidate2.subjectList.length > 1"
                  @click="delSubject(index)"
                  >删除</Button
                >
              </FormItem>
            </div>
            <Button
              @click="addScholr"
              v-if="formValidate2.subjectList.length < 5"
              style="margin-top: -10px; margin-left: 90px"
              >+</Button
            >
          </div>
          <FormItem>
            <Button
              type="primary"
              @click="suggesSubmit2('formValidate2')"
              style="
                float: right;
                margin-left: 20px;
                margin-top: 10px;
                width: 60px;
                height: 36px;
              "
              >确定</Button
            >
            <Button
              @click="suggesReset2('formValidate2')"
              style="
                margin-right: 20px;
                float: right;
                margin-top: 10px;
                width: 60px;
                height: 36px;
              "
              >取消</Button
            >
          </FormItem>
        </Form>
      </Modal>
      <!--作者基本信息添加-->
      <Modal
        v-model="modal"
        :title="title"
        :mask-closable="false"
        :footer-hide="true"
      >
        <Form
          ref="objAuthor"
          :label-width="90"
          :model="objAuthor"
          :rules="ruleValidate5"
          class="infoList"
        >
          <!-- <FormItem  :label="item.label" :key="index" v-for="(item,index) in authorInfo"  v-if="objAuthor[item.name]">
						<span v-text="objAuthor[item.name]"></span>
                    </FormItem> -->
          <v-item3
            :info="authorInfo"
            :rel="objAuthor"
            :commitSatus="status2"
            @fun="getDatas"
          >
            <FormItem slot="city" class="city">
              <Select
                v-if="provinceList.length"
                v-model="objAuthor.province"
                placeholder="请选择省"
                class="selectCity"
                @on-change="findCityList"
              >
                <Option
                  v-for="ite in provinceList"
                  :value="ite.code"
                  :key="ite.id"
                  >{{ ite.name }}</Option
                >
              </Select>
              <Select
                v-if="cityList.length"
                v-model="objAuthor.city"
                placeholder="请选择市"
                class="selectCity"
                @on-change="citys(objAuthor.city)"
              >
                <Option
                  v-for="ite in cityList"
                  :value="ite.code"
                  :key="ite.id"
                  >{{ ite.name }}</Option
                >
              </Select>
            </FormItem>
          </v-item3>
          <FormItem>
            <Button
              type="primary"
              @click="suggesReset('objAuthor')"
              :class="!flg ? 'bb' : 'aa'"
              >确定</Button
            >
            <Button
              @click="modal = false"
              style="
                margin-right: 70px;
                float: right;
                margin-top: 10px;
                width: 60px;
                height: 36px;
              "
              >取消</Button
            >
          </FormItem>
        </Form>
      </Modal>
      <!--作者基本信息修改-->
      <Modal
        v-model="modals"
        :title="title"
        :mask-closable="false"
        :footer-hide="true"
      >
        <Form
          ref="objAuthor1"
          :label-width="90"
          :model="objAuthor1"
          :rules="ruleValidate5"
          class="infoList"
        >
          <v-item4
            :info="authorInfo"
            :rel="objAuthor1"
            :commitSatus="status2"
            @fun="getDatas1"
          >
            <FormItem slot="city" class="city">
              <Select
                v-if="provinceList.length"
                v-model="objAuthor1.province"
                placeholder="请选择省"
                class="selectCity"
                @on-change="findCityList"
              >
                <Option
                  v-for="ite in provinceList"
                  :value="ite.code"
                  :key="ite.id"
                  >{{ ite.name }}</Option
                >
              </Select>
              <Select
                v-if="cityList.length"
                v-model="objAuthor1.city"
                placeholder="请选择市"
                class="selectCity"
              >
                <Option
                  v-for="ite in cityList"
                  :value="ite.code"
                  :key="ite.id"
                  >{{ ite.name }}</Option
                >
              </Select>
            </FormItem>
          </v-item4>
          <FormItem>
            <Button
              type="primary"
              @click="suggesResets('objAuthor1')"
              :class="!flg ? 'bb' : 'aa'"
              >确定</Button
            >
            <Button
              @click="modals = false"
              style="
                margin-right: 70px;
                float: right;
                margin-top: 10px;
                width: 60px;
                height: 36px;
              "
              >取消</Button
            >
          </FormItem>
        </Form>
      </Modal>
      <!--项目基金优惠-->
      <Modal v-model="modal3" title="基金稿件优惠规则">
        <Form :label-width="90" class="infoList">
          <p v-html="obj.fundPreferentialContent"></p>
        </Form>
      </Modal>
    </div>
  </div>
</template>

<script>
var vm = this;
const url = window.location.search;
const str = url.substring(url.indexOf("?") + 1).split("&");
let obj = {};
str.forEach((it) => {
  obj[it.substring(0, it.indexOf("="))] = it.substring(it.indexOf("=") + 1);
});
import {
  fundList,
  contributionInfo,
  addInfo,
  authorInfo,
  addAuthorInfo,
  system,
} from "./const.js";
import {
  email,
  realName,
  select,
  upload,
  empty,
  empty1,
  Slash,
  phone,
  identity,
  verificationCode,
  pws,
} from "@/const/formValidate.js";
import item from "@/components/item";
import item1 from "@/components/item1";
import item2 from "@/components/item2";
import item3 from "@/components/item3";
import item4 from "@/components/item4";
import city from "@/components/city";
import level from "@/components/level";
import job from "@/components/job";
export default {
  components: {
    "v-item": item,
    "v-item1": item1,
    "v-item2": item2,
    "v-item3": item3,
    "v-item4": item4,
    "v-city": city,
    "v-level": level,
    "v-job": job,
  },
  data() {
    return {
      action: "",
      flg1: false,
      flg: true,
      cindex: "",
      isload: false,
      provinceList: [],
      anim: 1,
      resultFlag: "",
      disabled: true,
      animal: "已注册用户",
      modal3: false,
      perId: sessionStorage.getItem("perId"),
      perName: this.$route.query.perName,
      articleId: this.$route.query.articleId,
      flag: "",
      tuixiuOpinion: "",
      postilFile: "",
      status: false,
      fundList,
      addInfo,
      authorInfo,
      addAuthorInfo,
      system,
      contributionInfo,
      defaultList: [],
      defaultList1: [],
      defaultList2: [],
      provinceList: [],
      cityList: [],
      obj: {},
      title: "",
      ind: "",
      modal: false,
      modals: false,
      modal1: false,
      modal2: false,
      status1: false,
      status2: false,
      status3: false,
      prevId: 0,
      oneSubjectList: [],
      twoSubjectList: [],
      dictList: [],
      subject: [],
      zindex: null,
      isLength: false,
      zclist: ["senior", "subSenior", "middle", "elementary"],
      dictSc1: "",
      dictScThree: [],
      twoResearchList: [],
      threeResearchList: [],
      // firstAuthorList:[],//第一作者数组
      // correspondingAuthorList:[],//通讯作者数组
      objAuthor: {},
      objAuthor1: {},
      authorType: "", //作者类型
      authorType1: "",
      Type: "", //作者类型
      params: {
        title: "",
        articlePath: "",
        annexPath: "",
        articleKey: "",
        articleNo: "",
        id: "", //稿件id
        periodicalId: "",
        submissionId: "", //投稿人（当前登录人）
        submissionName: "",
        copyrightAgreement: "",
        authorRequestList: [], //其他作者
        oneAuthor: {}, //第一作者
        correspondingAuthor: {}, //通讯作者
        libraryClassifyNumber: "",
        editingId: "",
        must: "bixu",
        foundationItemList: [
          //基金项目
          {
            id: "",
            fundLevel: "",
            fundName: "",
            fundNo: "",
            fundFileList: [],
          },
        ],
        foundationFlag: "",
        researchField: {
          //研究领域
          //						articleId:'',
          //						custom:'',
          //						id:'',
          //						levelOne:'',
          //						levelThree:'',
          //						levelTwo:'',
        },
        hopePublishDate: "",
        leaveMsg: "",
        summary: "",
      },
      ruleValidate: {
        title: Slash("文章标题"),
        must: empty(),
        foundationItemList: empty(),
        foundationFlag: empty(),
        // summary:empt('摘要'),
        // articleKey:empt('关键词'),
        editingId: empty(),
        articlePath: empty("稿件"),
      },
      //添加作者
      formValidate1: {
        phone: "",
        userName: "",
      },
      ruleValidate1: {
        phone: phone("手机号/账号"),
        userName: empty("作者姓名"),
      },
      //添加非作者
      formValidate3: {
        nickName: "",
        sex: "",
        birthday: "",
        education: "",
        unit: "",
        title: "",
        Research: "",
        phone: "",
        email: "",
      },
      ruleValidate3: {
        nickName: empty("姓名"),
        // email:email('邮箱'),
      },
      recommendData: [], //推荐文献数据
      // formValidate5:{
      // 	area:'',
      // 	birthday:'',
      // 	city:'',
      // 	education:'',
      // 	email:'',
      // 	id:'',
      // 	phone:'',
      // 	province:'',
      // 	researchField:'',
      // 	sex:'',
      // 	professional:'',
      // 	unit:'',
      // 	name:'',
      // 	oauthFlag:1,
      // },
      ruleValidate5: {
        area: empty(""),
        birthday: empty(""),
        education: empty(""),
        email: empty(""),
        researchField: empty(""),
        sex: empty(""),
        title: empty(""),
        unit: empty(""),
      },
      // formValidate:{},
      //添加作者基本信息
      formValidate2: {
        nickName: "",
        phone: "",
        birthday: "",
        city: "",
        education: "",
        email: "",
        province: "",
        sex: "",
        unit: "",
        userId: "",
        subjectList: [
          {
            custom: "",
            id: "",
            levelOne: "",
            levelOneName: "",
            levelThree: "",
            levelThreeName: "",
            levelTwo: "",
            levelTwoName: "",
            userId: "",
          },
        ],
        titleList: [
          {
            id: "",
            titleLevelOne: "",
            titleLevelThree: "",
            titleLevelTwo: "",
            userId: "",
          },
        ],
      },
      totalDictRules: {
        titleLevelThree: select("职称"),
      },
      subjectRules: {
        levelThree: select("研究方向"),
        custom: empty("研究方向"),
      },
      FundProjects: {
        fundLevel: select(""),
      },
      FundProjects1: {
        fundNo: empty(""),
      },
      FundProjects2: {
        fundName: empty(""),
      },
      FundProjects3: {
        fundFileList: empty(""),
      },
      ruleValidate2: {
        phone: phone("手机"),
        email: email("邮箱"),
        nickName: empty("姓名"),
        birthday: empty("出生年月"),
        sex: empty("性别"),
        province: empty("（省）"),
        city: empty("（市）"),
        education: select("学历"),
        unit: empty("工作单位"),
      },
      birthdayss: "",
      code: "",
      author: {},
    };
  },
  mounted() {
    vm = this;
    vm.userInfo = JSON.parse(sessionStorage.getItem("userInf"));
    vm.formValidate2.userId = vm.userInfo.userId;
    vm.params.periodicalId = vm.perId;
    vm.params.submissionId = vm.userInfo.userId;
    vm.params.submissionName = vm.userInfo.nickName;
    vm.editor();
    vm.copyrightAgreement();
    vm.findProvinceList();
    vm.getDictList();
    vm.getsubject();
    vm.getSubjectList();
    vm.recommendList();
    setTimeout(() => {
      vm.articleEcho();
    }, 500);
  },
  methods: {
    //点击推荐的文献跳转百科详情
    checkBK(item) {
      // 版本切换
      window.open(
        vm.$global.bkzxUrl +
          `?sesionId=${obj.sesionId}&token=${obj.token}&prid=${item.articleIds}#/paperds?id=${item.articleIds}`
      );
    },
    handleFormatError(file) {
      this.$Message.destroy();
      this.$Message.warning("文件格式错误");
    },
    //参考文献推荐
    recommendList() {
      vm.$apis.manage.recommendList({ articleId: vm.articleId }).then((res) => {
        vm.recommendData = res.content.list.list;
      });
    },
    //稿件回显
    articleEcho() {
      if (!vm.articleId) {
        return;
      }
      vm.$apis.manage
        .queryArticleInfoById({
          articleId: vm.articleId,
        })
        .then((res) => {
          if (res.messageType == "Success") {
            vm.flag = res.content.articleVo.articleStatus;
            let data = res.content.articleVo;
            vm.params.title = data.title;
            vm.params.oneAuthor = data.oneAuthor ? data.oneAuthor : {};
            // vm.firstAuthorList.push(vm.params.oneAuthor);
            vm.params.authorRequestList = data.authorInfo
              ? data.authorInfo
              : [];
            vm.params.correspondingAuthor = data.correspondingAuthor
              ? data.correspondingAuthor
              : {};
            // if(vm.params.correspondingAuthor){
            // vm.correspondingAuthorList.push(vm.params.correspondingAuthor);
            // }

            vm.params.summary = data.summary;
            vm.params.articleKey = data.articleKey;
            vm.params.libraryClassifyNumber = data.libraryClassifyNumber;
            data.articleFoundation.map((item) => {
              item.fundLevel = String(item.fundLevel);
              return item;
            });
            vm.params.foundationFlag = String(data.foundationFlag);
            vm.params.foundationItemList = data.articleFoundation.length
              ? data.articleFoundation
              : [
                  {
                    id: "",
                    fundLevel: "",
                    fundName: "",
                    fundNo: "",
                    fundFileList: [
                      {
                        fileUrl: "",
                        name: "",
                      },
                    ],
                  },
                ];
            vm.params.annexPath = data.annexPath;
            vm.params.copyrightAgreement = data.copyrightAgreement;
            vm.params.hopePublishDate = data.hopePublishDate
              ? data.hopePublishDate.split(" ")[0]
              : "";
            vm.params.editingId = data.editingId;
            if (vm.flag == 1) {
              vm.contributionInfo[0].disabled = true;
            }
            if (vm.$route.query.flags == 2) {
              vm.params.articlePath = data.articlePath;
            }
            vm.params.leaveMsg = data.leaveMsg;
            vm.params.id = data.id;
            vm.params.articleNo = data.articleNo;
            vm.params.researchField = data.researchField
              ? data.researchField
              : {};
            vm.twoResearchList =
              data.researchField && data.researchField.levelOne
                ? vm.subject[data.researchField.levelOne]
                : [];
            vm.threeResearchList =
              data.researchField && data.researchField.levelTwo
                ? vm.subject[data.researchField.levelTwo]
                : [];
            vm.tuixiuOpinion = res.content.tuixiuOpinion; //退修意见
            vm.postilFile = res.content.postilFile; //批注文档
          }
        });
    },
    //删除稿件
    deletes(index, cindex) {
      vm.params.foundationItemList[index].fundFileList.splice(cindex, 1);
    },
    //下载稿件
    download(index, cindex) {
      window.location.href =
        vm.$global.url +
        `/web/download/downloadCommon?downloadPath=${vm.params.foundationItemList[index].fundFileList[cindex].fileUrl}&fileName=${vm.params.foundationItemList[index].fundFileList[cindex].name}`;
    },
    getData(data) {
      vm.params = data;
    },

    //添加作者
    addAuthor(type) {
      if (type == 1) {
        vm.title = "添加第一作者";
      } else if (type == 2) {
        vm.title = "添加其他作者";
      } else {
        vm.title = "通讯作者";
      }
      vm.authorType = type;
      vm.modal1 = true;
      if (vm.authorType == 3) {
        vm.ruleValidate3.nickName = empty("姓名");
        vm.ruleValidate3.sex = empty("性别");
        vm.ruleValidate3.birthday = empty("出生年份");
        vm.ruleValidate3.education = select("学历");
        vm.ruleValidate3.unit = empty("工作单位");
        vm.ruleValidate3.title = empty("职称");
        vm.ruleValidate3.Research = empty("研究方向");
        vm.ruleValidate3.email = email("邮箱");
      } else {
        vm.ruleValidate3.nickName = empty("姓名");
        vm.ruleValidate3.sex = "";
        vm.ruleValidate3.birthday = "";
        vm.ruleValidate3.education = "";
        vm.ruleValidate3.unit = "";
        vm.ruleValidate3.title = "";
        vm.ruleValidate3.Research = "";
        vm.ruleValidate3.email = "";
      }
    },
    getData1(data) {
      vm.formValidate1 = data;
    },
    span() {
      vm.resultFlag = "";
      vm.modal1 = false;
      vm.modal2 = true;
    },
    suggesSubmit1(name) {
      vm.formValidate1.birthday = vm.$global.transferYear(
        vm.formValidate1.birthday
      );
      vm.status1 = !vm.status1;
      vm.$refs[name].validate((valid) => {
        if (valid) {
          vm.$apis.manage
            .findAuthorByPhoneAndName(vm.formValidate1)
            .then((res) => {
              if (res.resultCode == 200) {
                vm.formValidate2.nickName = vm.formValidate1.userName;
                vm.formValidate2.phone = vm.formValidate1.phone;
                let data = res.content.resultInfo;
                vm.resultFlag = data.resultFlag;
                if (data.resultFlag == 1) {
                  //已注册
                  vm.modal1 = false;
                  // vm.flg=true
                  vm.authorInfo = vm.authorInfo.map((item) => {
                    item.disabled = false;
                    return item;
                  });
                  vm.authorInfo[0].disabled = true;
                  vm.authorInfo[8].disabled = true;
                  vm.modal = true;
                  vm.cindex = "";
                  vm.$refs["formValidate1"].resetFields();
                  let author = {};
                  vm.objAuthor = data.userInfo;
                  vm.findCityList(vm.objAuthor.province);
                  // vm.objAuthor.sex = vm.objAuthor.sex==1?'男':'女';
                  // if(vm.objAuthor.sex==1){
                  // 	vm.objAuthor.sex='男'
                  // }else if(vm.objAuthor.sex==0){
                  // 	vm.objAuthor.sex='女'
                  // }
                  // vm.objAuthor.birthday = vm.objAuthor.birthday?new Date(vm.objAuthor.birthday).getFullYear():'';
                  // let provinceName = '';
                  // let cityName = '';
                  // vm.provinceList.forEach(item => {
                  // 	if (item.code == vm.objAuthor.province) {
                  // 		provinceName = item.name;
                  // 	}
                  // })
                  // vm.cityList.forEach(item => {
                  // 	if (item.code == vm.objAuthor.city) {
                  // 		cityName = item.name
                  // 	}
                  // })
                  // if(cityName==""){
                  // 	vm.objAuthor.area = provinceName;

                  // }else if(cityName){
                  // 	vm.objAuthor.area = provinceName+"/"+cityName;
                  // }
                  author = {
                    authorId: vm.objAuthor.userId,
                    companyName: vm.objAuthor.unit,
                    phone: vm.objAuthor.phone,
                    name: vm.objAuthor.userName,
                    professional: vm.objAuthor.title,
                    researchSubject: vm.objAuthor.researchField,
                    oauthFlag: 1,
                    province: vm.objAuthor.province,
                    city: vm.objAuthor.city,
                    // area:vm.objAuthor.area,
                    sex: vm.objAuthor.sex,
                    birthday: vm.objAuthor.birthday,
                    education: vm.objAuthor.education,
                    email: vm.objAuthor.email,
                  };
                  vm.author = author;
                } else if (data.resultFlag == 3) {
                  //已注册但姓名错误
                  vm.$Message.destroy();
                  vm.$Message.warning("作者姓名输入错误，请核对后重新输入。");
                }
                //								vm.$refs[name].resetFields();
              } else {
                vm.$Message.destroy();
                vm.$Message.warning(res.resultDesc);
              }
            });
        }
      });
    },

    suggesReset1(name) {
      vm.resultFlag = "";
      vm.$refs[name].resetFields();
      vm.modal1 = false;
    },
    //添加作者回显
    getDatas(data) {
      if (
        vm.author.area == "" ||
        vm.author.authorId == "" ||
        vm.author.birthday == "" ||
        vm.author.companyName == "" ||
        vm.author.education == "" ||
        vm.author.email == "" ||
        vm.author.name == "" ||
        vm.author.phone == "" ||
        vm.author.professional == "" ||
        vm.author.province == "" ||
        vm.author.researchSubject == "" ||
        vm.author.sex
      ) {
        (vm.author.authorId = data.id),
          (vm.author.companyName = data.unit),
          (vm.author.phone = data.phone),
          (vm.author.name = data.userName),
          (vm.author.professional = data.title),
          (vm.author.researchSubject = data.researchField),
          (vm.author.province = data.province),
          (vm.author.city = data.city),
          // vm.author.area=data.area,
          (vm.author.sex = data.sex),
          (vm.author.birthday = data.birthday),
          (vm.author.education = data.education),
          (vm.author.email = data.email);
      }
    },
    citys(val) {
      vm.author.province = vm.objAuthor.province;
      vm.author.city = val;
    },
    suggesReset(name) {
      vm.$refs[name].validate((valid) => {
        if (valid) {
          if (
            vm.author.authorId &&
            vm.author.birthday &&
            vm.author.companyName &&
            vm.author.education &&
            vm.author.email &&
            vm.author.name &&
            vm.author.phone &&
            vm.author.professional &&
            vm.author.province &&
            vm.author.researchSubject &&
            vm.author.sex
          ) {
            vm.modal = false;
            if (vm.authorType == 1) {
              // vm.firstAuthorList = [];
              vm.author.level = 1;
              // vm.firstAuthorList.push(vm.author);
              vm.params.oneAuthor = vm.author;
            }
            if (vm.authorType == 2) {
              vm.author.level = 2;
              vm.cindex = String(vm.cindex);
              if (vm.cindex == "") {
                vm.params.authorRequestList.push(vm.author);
              } else {
                let index = Number(vm.cindex);
                vm.params.authorRequestList[index] = vm.author;
              }
              vm.cindex = "";
            }
            if (vm.authorType == 3) {
              // vm.correspondingAuthorList = [];
              vm.author.level = 3;
              // vm.correspondingAuthorList.push(vm.author);
              vm.params.correspondingAuthor = vm.author;
            }
          }
        }
      });
      // vm.flg=true
    },
    //添加作者回显
    getDatas1(data) {
      vm.objAuthor1 = data;
      vm.objAuthor1.researchSubject = data.researchField;
      vm.objAuthor1.professional = data.title;
      vm.objAuthor1.name = data.userName;
      vm.objAuthor1.authorId = data.id;
      vm.objAuthor1.companyName = data.unit;
      // vm.findCityList(vm.objAuthor1.province)
    },
    suggesResets(name) {
      vm.$refs[name].validate((valid) => {
        if (valid) {
          vm.modals = false;
          if (vm.authorType1 == 1) {
            vm.objAuthor1.level = 1;
            vm.params.oneAuthor = vm.objAuthor1;
          }
          if (vm.authorType1 == 2) {
            vm.objAuthor1.level = 2;
            vm.cindex = String(vm.cindex);
            if (vm.cindex == "") {
              vm.params.authorRequestList.push(vm.objAuthor1);
            } else {
              let index = Number(vm.cindex);
              vm.params.authorRequestList[index] = vm.objAuthor1;
            }
            vm.cindex = "";
          }
          if (vm.authorType1 == 3) {
            vm.objAuthor1.level = 3;
            vm.params.correspondingAuthor = vm.objAuthor1;
          }
        }
      });
      // vm.flg=true
    },
    getData3(data) {
      vm.formValidate3 = data;
    },
    //非系统
    suggesSubmit3(name) {
      if (vm.formValidate3.birthday == "") {
        vm.formValidate3.birthday = "";
      } else {
        vm.formValidate3.birthday = vm.$global.transferYear(
          vm.formValidate3.birthday
        );
      }
      if (vm.formValidate3.sex == "") {
        vm.formValidate3.sex = "";
      } else if (vm.formValidate3.sex == 1) {
        vm.formValidate3.sex = "男";
      } else if (vm.formValidate3.sex == 0) {
        vm.formValidate3.sex = "女";
      }

      vm.$refs.formValidate3.validate((valid) => {
        if (valid) {
          let author = {};
          author = {
            companyName: vm.formValidate3.unit,
            phone: vm.formValidate3.phone,
            sex: vm.formValidate3.sex,
            birthday: vm.formValidate3.birthday,
            education: vm.formValidate3.education,
            email: vm.formValidate3.email,
            oauthFlag: 0,
            name: vm.formValidate3.nickName,
            professional: vm.formValidate3.title,
            researchSubject: vm.formValidate3.researchField,
            sex: vm.formValidate3.sex,
            province: vm.objAuthor.province,
          };
          if (vm.authorType == 2) {
            author.level = 2;

            vm.params.authorRequestList.push(author);

            vm.objAuthor = author;
            if (vm.objAuthor.sex == "") {
              vm.objAuthor.sex = "";
            } else if (vm.objAuthor.sex == 1) {
              vm.objAuthor.sex = "男";
            } else if (vm.objAuthor.sex == 0) {
              vm.objAuthor.sex = "女";
            }
            vm.modal1 = false;
            vm.$refs.formValidate3.resetFields();
            vm.formValidate3.email = "";
            vm.authorType = "";
            vm.animal = "已注册用户";
          } else if (vm.authorType == 3) {
            vm.correspondingAuthorList = [];
            author.level = 3;
            vm.correspondingAuthorList.push(author);
            vm.params.correspondingAuthor = author;
            vm.modal1 = false;
            vm.$refs.formValidate3.resetFields();
            vm.authorType = "";
            vm.animal = "已注册用户";
          }
        }
      });
    },
    //非注册用户取消键
    suggesReset3(name) {
      vm.modal1 = false;
      vm.$refs.formValidate3.resetFields();
      vm.animal = "已注册用户";
    },
    //作者基本信息展示(
    infos(type, data, index) {
      vm.authorType1 = type;
      vm.cindex = index;
      if (type == 1) {
        vm.title = "查看第一作者";
      } else if (type == 2) {
        vm.title = "查看其他作者";
      } else {
        vm.title = "查看通讯作者";
      }
      data.sex = String(data.sex);
      if (data.birthday && data.birthday.length > 4) {
        data.birthday = data.birthday.substring(0, 4);
      }

      vm.objAuthor1 = data;
      vm.objAuthor1.id = data.authorId;
      vm.objAuthor1.unit = data.companyName;
      vm.objAuthor1.userName = data.name;
      vm.objAuthor1.title = data.professional;
      vm.objAuthor1.researchField = data.researchSubject;
      vm.findCityList(vm.objAuthor1.province);
      vm.modals = true;

      // 	// vm.objAuthor= data
      //     if(vm.objAuthor.sex==""){
      //     		vm.objAuthor.sex=""
      //     }else if(vm.objAuthor.sex==1){
      //     	vm.objAuthor.sex='男'
      //     }else if(vm.objAuthor.sex==0){
      //     	vm.objAuthor.sex='女'
      //     }
      //
      // 		vm.modal = true;

      // if(type==1){
      // 		vm.$apis.manage.findAuthorByAuthorId({
      // 			authorId:data.authorId,
      // 			}).then(res => {
      // 				if (res.resultCode == 200) {
      // 					vm.objAuthor = res.content.resultInfo.userInfo;

      // 					if(vm.objAuthor.sex==1){
      // 						vm.objAuthor.sex='男'
      // 					}else if(vm.objAuthor.sex==0){
      // 						vm.objAuthor.sex='女'
      // 					}
      // 					vm.objAuthor.birthday = vm.objAuthor.birthday?new Date(vm.objAuthor.birthday).getFullYear():'';
      // 					let provinceName = '';
      // 					var cityName = '';
      // 					vm.provinceList.forEach(item => {
      // 						if (item.code == vm.objAuthor.province) {
      // 							provinceName = item.name;
      // 						}
      // 					})
      // 						vm.cityList.forEach(item => {
      // 							if (item.code == vm.objAuthor.city) {
      // 								cityName = item.name
      // 							}
      // 						})

      // 						if(cityName==""){
      // 							vm.objAuthor.area = provinceName;

      // 						}else if(cityName){
      // 							vm.objAuthor.area = provinceName+"/"+cityName;
      // 						}

      // 					if(type == 1){
      // 						vm.title = '查看第一作者';
      // 					}else if (type == 2) {
      // 						vm.title = '查看其他作者';
      // 					}else{
      // 						vm.title = '查看通讯作者';
      // 					}
      // 				}
      // 			})
      // 			vm.modal = true;

      // }else if(type==2||type==3){
      // 			if(vm.animal== '已注册用户'){
      // 				if(data.authorId){
      // 				vm.$apis.manage.findAuthorByAuthorId({
      // 				authorId:data.authorId,
      // 			}).then(res => {
      // 				if (res.resultCode == 200) {
      // 					vm.objAuthor = res.content.resultInfo.userInfo;
      // 					if(vm.objAuthor.sex==1){
      // 						vm.objAuthor.sex='男'
      // 					}else if(vm.objAuthor.sex==0){
      // 						vm.objAuthor.sex='女'
      // 					}
      // 					// vm.objAuthor.sex = vm.objAuthor.sex==1?'男':'女';
      // 					vm.objAuthor.birthday = vm.objAuthor.birthday?new Date(vm.objAuthor.birthday).getFullYear():'';
      // 						let provinceName = '';
      // 					let cityName = '';
      // 					vm.provinceList.forEach(item => {
      // 						if (item.code == vm.objAuthor.province) {
      // 							provinceName = item.name;
      // 						}
      // 					})
      // 						vm.cityList.forEach(item => {
      // 							if (item.code == vm.objAuthor.city) {
      // 								cityName = item.name
      // 							}
      // 						})

      // 						if(cityName==""){
      // 							vm.objAuthor.area = provinceName;

      // 						}else if(cityName){
      // 							vm.objAuthor.area = provinceName+"/"+cityName;
      // 						}

      // 					if(type == 1){
      // 						vm.title = '查看第一作者';
      // 					}else if (type == 2) {
      // 						vm.title = '查看其他作者';
      // 					}else{
      // 						vm.title = '查看通讯作者';
      // 					}
      // 				}
      // 			})
      // 				}
      // 				vm.modal = true;
      // 			}
      // }
    },

    //获取作者基本信息
    getData2(data) {
      vm.formValidate2 = data;
      if (vm.formValidate2.province) {
        vm.findCityList(vm.formValidate2.province);
      }
    },
    //添加作者基本信息确认键
    suggesSubmit2(name) {
      vm.formValidate2.birthday = vm.$global.transferYear(
        vm.formValidate2.birthday
      );

      vm.$refs.formValidate1.resetFields();
      vm.status = !vm.status;
      vm.$refs[name].validate((valid) => {
        if (valid) {
          vm.formValidate2.subjectList.map((item) => {
            item.twoSubjectList = [];
            item.threeSubjectList = [];
            return item;
          });
          vm.formValidate2.titleList.map((item) => {
            item.dictScThree = [];
            return item;
          });
          var params2 = vm.$global.deepClone(vm.formValidate2);
          // 修改作者性别为1 0 第一作者和通讯作者唯一，其他作者可以有多个
          if (params2.oneAuthor && params2.oneAuthor.sex) {
            params2.oneAuthor.sex = params2.oneAuthor.sex == "男" ? 1 : 0;
          }
          if (params2.correspondingAuthor && params2.correspondingAuthor.sex) {
            params2.correspondingAuthor.sex =
              params2.correspondingAuthor.sex == "男" ? 1 : 0;
          }
          if (
            params2.authorRequestList &&
            params2.authorRequestList.length > 0
          ) {
            params2.authorRequestList.forEach((elem) => {
              if (elem.sex) {
                elem.sex = elem.sex == "男" ? 1 : 0;
              }
            });
          }
          vm.$apis.manage.registerAuthor(params2).then((res) => {
            if (res.resultCode == 200) {
              vm.$Message.success("添加成功");
              vm.modal2 = false;
              // vm.objAuthor = res.content.authorInfo;
              vm.$apis.manage
                .findAuthorByAuthorId({
                  authorId: res.content.authorInfo.userId,
                })
                .then((res) => {
                  vm.objAuthor = res.content.resultInfo.userInfo;
                  // if(vm.objAuthor.sex==1){
                  // 	vm.objAuthor.sex='男'
                  // }else if(vm.objAuthor.sex==0){
                  // 	vm.objAuthor.sex='女'
                  // }
                  // let provinceName = '';
                  // let cityName = '';
                  // vm.provinceList.forEach(item => {
                  // 	if (item.code == vm.objAuthor.province) {
                  // 		provinceName = item.name;
                  // 	}
                  // })
                  // if(cityName==""){
                  // 	vm.objAuthor.area = provinceName;
                  // }
                  let author = {};
                  author = {
                    authorId: vm.objAuthor.id,
                    companyName: vm.objAuthor.unit,
                    phone: vm.objAuthor.phone,
                    name: vm.objAuthor.userName,
                    professional: vm.objAuthor.title,
                    researchSubject: vm.objAuthor.researchField,
                    oauthFlag: 1,
                    province: vm.objAuthor.province,
                    city: vm.objAuthor.city,
                    // area:vm.objAuthor.area,
                    sex: vm.objAuthor.sex,
                    birthday: vm.objAuthor.birthday,
                    education: vm.objAuthor.education,
                    email: vm.objAuthor.email,
                  };
                  if (vm.authorType == 1) {
                    // vm.firstAuthorList = [];
                    author.level = 1;
                    // vm.firstAuthorList.push(author);
                    vm.params.oneAuthor = author;
                  } else if (vm.authorType == 2) {
                    author.level = 2;
                    vm.params.authorRequestList.push(author);
                  } else {
                    // vm.correspondingAuthorList = [];
                    author.level = 3;
                    // vm.correspondingAuthorList.push(author);
                    vm.params.correspondingAuthor = author;
                  }

                  vm.author = author;
                });
            } else {
              vm.$Message.destroy();
              vm.$Message.warning(res.resultDesc);
            }
            vm.$refs.formValidate2.resetFields();
          });
        }
      });
    },
    //添加作者基本信息取消键
    suggesReset2(name) {
      vm.$refs.formValidate2.resetFields();
      // vm.$refs[name].resetFields();
      vm.modal2 = false;
    },
    //是否基金项目
    change() {
      vm.params.foundationItemList = [
        {
          id: "",
          fundLevel: "",
          fundName: "",
          fundNo: "",
          fundFileList: [],
        },
      ];
    },
    //基金项目
    addFund(index) {
      var data = {
        id: "",
        fundLevel: "",
        fundName: "",
        fundNo: "",
        fundFileList: [],
      };
      vm.params.foundationItemList.push(data);
    },
    //删除
    delFund(index) {
      vm.params.foundationItemList.splice(index, 1);
    },
    //删除作者
    del(type, index) {
      if (type == 1) {
        vm.params.oneAuthor = {};
      }
      if (type == 2) {
        vm.params.authorRequestList.splice(index, 1);
      }
      if (type == 3) {
        vm.params.correspondingAuthor = {};
      }
    },
    //本文研究领域
    changeResearch(val) {
      vm.twoResearchList = vm.subject[val];
    },
    changeResearch1(val) {
      vm.threeResearchList = vm.subject[val];
    },

    //研究方向
    changeScholr(val) {
      vm.prevId = val;
      if (val) {
        vm.formValidate2.subjectList[vm.zindex].levelTwo = "";
        vm.formValidate2.subjectList[vm.zindex].twoSubjectList =
          vm.subject[val];
      }
    },
    changeScholr1(val) {
      if (val) {
        vm.formValidate2.subjectList[vm.zindex].levelThree = "";
        vm.formValidate2.subjectList[vm.zindex].threeSubjectList =
          vm.subject[val];
      }
    },
    addScholr() {
      var data = {
        id: "",
        custom: "",
        levelOne: null,
        levelTwo: null,
        levelThree: null,
        userId: "",
      };
      this.formValidate2.subjectList.push(data);
    },
    delSubject(index) {
      this.formValidate2.subjectList.splice(index, 1);
    },

    //职称1
    dictScChange1(val) {
      this.dictSc1 = val;
      this.dictScThree = [];
      let dictList = vm.dictList[val];
      let zc = vm.zclist[val - 1];
      vm.formValidate2.titleList[vm.zindex].titleLevelThree = "";
      vm.formValidate2.titleList[vm.zindex].titleLevelTwo = "";
    },

    //职称2
    dictScChange2(val) {
      let index = vm.formValidate2.titleList[vm.zindex].titleLevelOne;
      let zc = vm.zclist[val - 1];
      let dictList = vm.mapJobList(index, zc);
      vm.formValidate2.titleList[vm.zindex].titleLevelThree = "";
      vm.formValidate2.titleList[vm.zindex].dictScThree = dictList;
    },
    mapJobList(seriesId, gradeId) {
      let data = {};
      vm.dictList.forEach((item) => {
        if (item.id == seriesId) {
          data = item[gradeId];
        }
      });
      return data;
    },
    addDict() {
      var dic = {
        id: "",
        titleLevelOne: null,
        titleLevelTwo: null,
        titleLevelThree: null,
        userId: "",
      };
      this.formValidate2.titleList.push(dic);
    },
    delDict(index) {
      this.formValidate2.titleList.splice(index, 1);
    },
    //附件
    handleSuccess(res, file, fileList) {
      if (res.resultCode == 200) {
        vm.defaultList = [file];
        vm.params.annexPath = res.content.url;
      }
    },
    //稿件
    handleSuccess1(res, file, fileList) {
      if (res.resultCode == 200) {
        vm.defaultList1 = [file];
        vm.params.articlePath = res.content.url;
      }
    },
    //上传版权协议
    handleSuccess2(res, file, fileList) {
      if (res.resultCode == 200) {
        vm.params.copyrightAgreement = res.content.url;
      }
    },
    //证明材料
    getIndex(index) {
      vm.ind = index;
    },
    //基金项目上传
    handleSuccess3(res, file, fileList) {
      if (res.resultCode == 200) {
        vm.params.foundationItemList[vm.ind].fundFileList.push({
          fileUrl: res.content.url,
          name: file.name,
        });
      }
    },
    //责任采编
    editor() {
      vm.$apis.manage
        .queryEditingByUserId({
          periodicalId: vm.perId,
          userId: vm.userInfo.userId,
        })
        .then((res) => {
          if (res.messageType == "Success") {
            vm.contributionInfo[0].selectData = [];
            res.content.editingList.map((item, index) => {
              vm.contributionInfo[0].selectData.push({
                id: item.id,
                name: item.name,
              });

              if (vm.flag != 1) {
                if (res.content.editingId) {
                  vm.params.editingId = res.content.editingId;
                  vm.contributionInfo[0].disabled = true;
                } else {
                  vm.params.editingId = res.content.natureArticleHandler;
                  vm.contributionInfo[0].disabled = false;
                }
              }
            });
          }
        });
    },
    // //省
    // findProvinceList() {
    // 	vm.$apis.manage.findProvinceList().then(result => {
    // 		if(result.messageType == "Success") {
    // 			vm.addAuthorInfo[7].selectData = [];
    // 			vm.provinceList = result.content.areaList.map(item => {
    // 				vm.code=item.code,
    //                 vm.addAuthorInfo[7].selectData.push({
    // 					id:item.code,
    // 					name:item.name
    // 				})
    // 				return item;
    // 			});
    // 		}
    // 	});
    // },

    //省
    findProvinceList() {
      vm.$apis.manage.findProvinceList().then((result) => {
        if (result.messageType == "Success") {
          vm.provinceList = result.content.areaList;
        }
      });
    },

    // //市
    findCityList(code) {
      vm.cityList = [];
      if (code) {
        vm.$apis.manage
          .findAreaList({
            code: code,
          })
          .then((result) => {
            if (result.messageType == "Success") {
              vm.cityList = result.content.areaList;
            }
          });
      }
    },
    getCity(value) {
      vm.formValidate2.province = value.item.nativeProvince || "";
      vm.formValidate2.city = value.item.nativeCity || "";
    },
    getCity1(value) {
      vm.objAuthor1.province = value.item.nativeProvince || "";
      vm.objAuthor1.city = value.item.nativeCity || "";
    },
    //树结构
    getsubject() {
      vm.$apis.manage
        .treeList({
          prevId: vm.prevId,
        })
        .then((result) => {
          if (result.messageType == "Success") {
            vm.subject = result.content.list;
          }
        });
    },
    //学科列表
    getSubjectList() {
      vm.$apis.manage
        .subjectList({
          prevId: vm.prevId,
        })
        .then((result) => {
          if (result.messageType == "Success") {
            if (vm.prevId == 0) {
              vm.oneSubjectList = result.content.list;
            } else {
              vm.twoSubjectList = result.content.list;
            }
          }
        });
    },
    //职称列表
    getDictList() {
      vm.$apis.manage.titleList().then((result) => {
        if (result.messageType == "Success") {
          vm.dictList = result.content.list;
        }
      });
    },
    //版权协议
    copyrightAgreement() {
      vm.$apis.manage
        .querycopyrightAgreement({
          periodicalId: vm.perId,
        })
        .then((res) => {
          if (res.messageType == "Success") {
            vm.obj = res.content;
          }
        });
    },
    copyDown(type, path) {
      let fileName = "";
      if (type == 1) {
        fileName = "批注文档";
      } else {
        fileName = "版权协议转让书";
      }
      window.location.href =
        vm.$global.url +
        `/web/download/downloadCommon?
						fileName=${fileName}&downloadPath=${path}`;
    },
    //投稿保存
    saveInfo() {
      // if(vm.params.oneAuthor.sex=='女'){
      // 		vm.params.oneAuthor.sex=0
      // }else if(vm.params.oneAuthor.sex=='男'){
      // 		vm.params.oneAuthor.sex=1
      // }
      if (!vm.params.oneAuthor.authorId) {
        vm.$Message.destroy();
        vm.$Message.warning("请添加第一作者！");
        return;
      }
      if (vm.params.oneAuthor.birthday == "") {
        vm.params.oneAuthor.birthday = "";
      } else if (
        vm.params.oneAuthor.birthday &&
        String(vm.params.oneAuthor.birthday).length < 5
      ) {
        vm.params.oneAuthor.birthday = vm.params.oneAuthor.birthday + "-01-01";
      }

      vm.params.authorRequestList.map((item) => {
        // if(item.sex=='男'){
        // 	item.sex=1
        // }else if(item.sex=='女'){
        // 	item.sex=0
        // }
        if (item.birthday == "") {
          item.birthday = "";
        } else if (item.birthday && String(item.birthday).length == 4) {
          item.birthday = item.birthday + "-01-01";
        }
      });
      // if(vm.params.correspondingAuthor.sex=='女'){
      // 		vm.params.correspondingAuthor.sex=0
      // }else if(vm.params.correspondingAuthor.sex=='男'){
      // 		vm.params.correspondingAuthor.sex=1
      // }
      if (vm.params.correspondingAuthor.birthday == "") {
        vm.params.correspondingAuthor.birthday = "";
      } else if (
        vm.params.correspondingAuthor.birthday &&
        String(vm.params.correspondingAuthor.birthday).length == 4
      ) {
        vm.params.correspondingAuthor.birthday =
          vm.params.correspondingAuthor.birthday + "-01-01";
      }

      vm.$apis.manage.saveArticleForDraft(vm.params).then((res) => {
        if (res.resultCode == 200) {
          vm.$Message.success("保存成功");
          vm.params.id = res.content.article.id;
          vm.params.articleNo = res.content.article.articleNo;
        } else {
          vm.$Message.destroy();
          vm.$Message.warning(res.resultDesc);
        }
      });
    },
    //下一步
    nextStep(name) {
      vm.status = !vm.status;
      if (!vm.params.oneAuthor.authorId) {
        vm.$Message.destroy();
        vm.$Message.warning("请添加第一作者！");
        return;
      }
      // if(vm.params.oneAuthor.sex=='女'){
      // 		vm.params.oneAuthor.sex=0
      // }else if(vm.params.oneAuthor.sex=='男'){
      // 		vm.params.oneAuthor.sex=1
      // }
      if (vm.params.oneAuthor.birthday == "") {
        vm.params.oneAuthor.birthday = "";
      } else if (
        vm.params.oneAuthor.birthday &&
        String(vm.params.oneAuthor.birthday).length < 5
      ) {
        vm.params.oneAuthor.birthday = vm.params.oneAuthor.birthday + "-01-01";
      }
      vm.params.authorRequestList.map((item) => {
        // if(item.sex=='男'){
        // 	item.sex=1
        // }else if(item.sex=='女'){
        // 	item.sex=0
        // }
        if (item.birthday == "") {
          item.birthday = "";
        } else if (item.birthday && String(item.birthday).length == 4) {
          item.birthday = item.birthday + "-01-01";
        }
      });

      // if(vm.params.correspondingAuthor.sex=='女'){
      // 		vm.params.correspondingAuthor.sex=0
      // }else if(vm.params.correspondingAuthor.sex=='男'){
      // 		vm.params.correspondingAuthor.sex=1
      // }
      if (vm.params.correspondingAuthor.birthday == "") {
        vm.params.correspondingAuthor.birthday = "";
      } else if (
        vm.params.correspondingAuthor.birthday &&
        String(vm.params.correspondingAuthor.birthday).length == 4
      ) {
        vm.params.correspondingAuthor.birthday =
          vm.params.correspondingAuthor.birthday + "-01-01";
      }
      vm.params.hopePublishDate = vm.params.hopePublishDate
        ? vm.$global.transferYear(vm.params.hopePublishDate)
        : "";
      vm.$refs[name].validate((valid) => {
        if (valid) {
          var params2 = vm.$global.deepClone(vm.params);
          // 修改作者性别为1 0 第一作者和通讯作者唯一，其他作者可以有多个
          if (params2.oneAuthor && params2.oneAuthor.sex) {
            params2.oneAuthor.sex = params2.oneAuthor.sex == "男" ? 1 : 0;
          }
          if (params2.correspondingAuthor && params2.correspondingAuthor.sex) {
            params2.correspondingAuthor.sex =
              params2.correspondingAuthor.sex == "男" ? 1 : 0;
          }
          if (
            params2.authorRequestList &&
            params2.authorRequestList.length > 0
          ) {
            params2.authorRequestList.forEach((elem) => {
              if (elem.sex) {
                elem.sex = elem.sex == "男" ? 1 : 0;
              }
            });
          } 
          vm.$apis.manage.saveArticle(params2).then((res) => {
            if (res.resultCode == 200) {
              vm.$router.push({
                path: "./submissionInformation",
                query: {
                  perId: vm.perId,
                  perName: vm.perName,
                  articleId: res.content.article.id,
                  flag: vm.flag,
                },
              });
            } else {
              vm.$Message.destroy();
              vm.$Message.warning(res.resultDesc);
            }
          });
        } else {
          vm.$Message.destroy();
          vm.$Message.warning("请填写完整的投稿信息！");
        }
      });
    },
  },
};
</script>

<style scoped="scoped" lang="scss" scoped>
/deep/ .ivu-form-item-required .ivu-form-item-label:before {
  // position: absolute;
  // left: 6%;
}
/deep/ .ivu-form .ivu-form-item-label {
  // text-align-last: justify;
  display: block;
  width: 100px;
  text-align: justify;
  text-justify: distribute-all-lines;
  /*ie6-8*/
  text-align-last: justify;
}

// .box{
// 	 overflow-x: hidden;
// }

.content {
  width: 1200px;
  min-width: 300px;
  // max-width: 700px;
  margin: 0 auto;
  // overflow: hidden;
  // overflow-x: scroll;
  padding: 30px 50px;
  // .content_left,.content_right{
  // 	overflow-y: auto;
  // 	height: 900px;//高度是指滚动窗口的高度，必须有
  // 	// &::-webkit-scrollbar { //去除滚动条，设置滚动条的背景颜色为透明
  //     //    background-color: transparent;
  //     //    display:none;
  //     // }

  // }
  .content_left {
    float: left;
    width: 765px;
    margin-bottom: 70px;
    .title {
      text-align: center;
      font-weight: 700;
      font-size: 20px;
      margin-bottom: 50px;
    }
    .add {
      color: #508bb5;
      font-size: 18px;
      margin-left: 10px;
      cursor: pointer;
    }
    .author {
      display: flex;
      justify-content: space-between;
      .name {
        color: #508bb5;
        cursor: pointer;
        display: inline-block;
        width: 73px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span:nth-child(2) {
        display: inline-block;
        width: 90px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span:nth-child(3) {
        display: inline-block;
        width: 114px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      span:nth-child(4) {
        display: inline-block;
        width: 237px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .del {
        color: red;
        font-size: 18px;
        cursor: pointer;
      }
    }
    .btn {
      width: 120px;
    }
    .btn:first-child {
      margin-right: 30px;
      background: #508bb5;
    }
  }
  .content_right {
    float: right;
    width: 320px;
    position: fixed;
    height: 80vh; //高度是指滚动窗口的高度，必须有
    // overflow-y: auto;
    margin-left: 850px;
    .container {
      padding: 20px 30px;
      border: 1px solid #eee;
      height: 90%;
      overflow-y: auto;
      .title {
        text-align: center;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 20px;
      }
      // &::-webkit-scrollbar { //去除滚动条，设置滚动条的背景颜色为透明
      // 	background-color: transparent;
      // 	display:none;
      // }
    }
    .down {
      z-index: 100;
      position: absolute;
      bottom: 0;
      top: 90%;
      left: 0;
      right: 0;
      color: #508bb5;
      text-align: center;
      font-size: 14px;
      margin-top: 20px;
      cursor: pointer;
    }
  }
  .coverImg {
    width: 100%;
    height: 100%;
    /*position: absolute;
        top: 0;
        left: 0;*/
    object-fit: cover;
  }
  .uploadClass {
    /deep/ .ivu-upload-drag {
      width: 150px;
      position: relative;
    }
  }
}
.btn {
  width: 120px;
  height: 30px;
  color: #fff;
  margin-top: 10px;
  background: #03a9f4;
  border: 1px solid transparent; //自定义边框
  outline: none; //消除默认点击蓝色边框效果
  border-radius: 5px;
}
.button {
  width: 100%;
  height: 50px;
  border-top: 1px solid #ccc;
  line-height: 50px;
  padding-left: 17%;
  background: #fff;
  // position:absolute;
  // bottom:10px;
  // left:0px;
  position: absolute;
  bottom: 0;
  top: 91%;
  left: 0;
  right: 0;
  z-index: 100;
}
.animal {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 10px 0 30px 0;
}
.spam {
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/ .foundationItemLists .ivu-upload-list {
  width: 700px;
  display: flex;
  position: absolute;
  left: -214%;
  top: 40px;
}
/deep/ .ivu-upload-list-file {
  padding: 0;
}
.Echo {
  width: 700px;
  display: flex;
  position: absolute;
  left: -214%;
  top: 40px;
}
/deep/.Echo li .ivu-poptip-rel {
  width: 100px;
  line-height: 15px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Echo li {
  margin-right: 20px;
}
.aa {
  margin-right: 150px;
  float: right;
  margin-top: 10px;
  width: 60px;
  height: 36px;
}
.bb {
  margin-right: 200px;
  float: right;
  margin-top: 10px;
  width: 60px;
  height: 36px;
}
/deep/ .city .ivu-select {
  width: 49%;
}
</style>



// WEBPACK FOOTER //
// src/views/manage/contributorInformation/index.vue